// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"511c3a49dcb310b875ae","116":"8a725cf7ee625c5c6822","117":"2c28519629d6b152f33e","165":"0e019bf3f7efc88772af"}[chunkId] + ".chunk.js";
};